export enum ProductAction {
  Create = 'create',
  Delete = 'delete',
  Duplicate = 'duplicate',
  Update = 'update',
}
